import { CheckCircleOutlined } from '@ant-design/icons';
import type { MouseEvent } from 'react';
import styled from 'styled-components';

import useColor from '@/hooks/domain/useColor';

type Props = {
  status: boolean;
  onClick: (status: boolean, e?: MouseEvent) => void;
};

const RadioButton = (props: Props) => {
  const color = useColor();
  if (props.status)
    return (
      <CheckCircleOutlined
        style={{ color: color.primary100, fontSize: 16 }}
        onClick={(e) => props.onClick(false, e)}
      />
    );
  return <Style onClick={() => props.onClick(true)}></Style>;
};

const Style = styled.div`
  width: 16px;
  height: 16px;
  border-radius: 16px;
  border: 1px solid ${(props) => props.theme.colors.gray600};
  cursor: pointer;
`;

export default RadioButton;
